import { Box, Divider, Grid, Typography } from "@mui/material";
import Color from "../../layouts/Color";

const ListCardItem = [
    {
        name: 'VISA Prepaid Standard',
        image: './assets/images/product/standard.png',
        overview: 'Unlimited withdrawals',
        benifits: [
            'Free card issuance',
            'Free early payment',
            'Unlimited withdrawals'
        ],
        annualFees: {
            mainCard: '0',
            otherCard: '100.000'
        },
        description: 'The annual fee is refundable under the annual fee refund scheme if the customer makes a transaction within 90 days from the date the annual fee is debited to the Customers Credit Card account.'
    },
    {
        name: 'Virtual VISA Prepaid Standard',
        image: './assets/images/product/platinum.png',
        overview: 'Unlimited bonus points',
        benifits: [
            'Accumulate and cashback 0.5% on domestic spending (electronic)',
            'Accumulate and cashback 0.7% on other foreign spending',
            'Accumulate and cash back 3% when spending at OPENWAY VIETNAM'
        ],
        annualFees: {
            mainCard: '200.000',
            otherCard: '200.000'
        },
        description: 'Withdraw up to 100% of the limit.'
    },
    {
        name: 'VISA Credit Standard',
        image: './assets/images/product/vip.png',
        overview:'Enjoy the offer for VISA VIP',
        benifits: [
            'Accumulate and cashback 0.5% on domestic spending',
            'Accumulate and cash back 1% on other foreign spending',
            'Accumulate and cash back 3% when spending at OPENWAY VIETNAME'
        ],
        annualFees: {
            mainCard: '1.000.000',
            otherCard: 'FREE'
        },
        description: 'The annual fee is refundable under the annual fee refund scheme if the customer makes a transaction within 90 days from the date the annual fee is debited to the Customers Credit Card account.'
    },  
    {
      name: 'VISA Credit Platium Account-NEW',
      image: './assets/images/product/vip.png',
      overview:'Enjoy the offer for VISA VIP',
      benifits: [
          'Accumulate and cashback 0.5% on domestic spending',
          'Accumulate and cash back 1% on other foreign spending',
          'Accumulate and cash back 3% when spending at OPENWAY VIETNAME'
      ],
      annualFees: {
          mainCard: '1.000.000',
          otherCard: 'FREE'
      },
      description: 'The annual fee is refundable under the annual fee refund scheme if the customer makes a transaction within 90 days from the date the annual fee is debited to the Customers Credit Card account.'
    }   
]


const box = {
    marginTop: '70px'
}

const container = {
    display: 'flex',
    alignItems: 'center',
    mb: '60px'
}

const imgGrid = { paddingRight: '30px' }

const img = { width: '100%' }

const contentGrid = { textAlign: 'left' }

const text = { mb: '15px' }

const title = { color: Color.Main, fontWeight: '400', mb: '10px' }

const list = { marginBottom: '5px' }

const listUl = { margin: 0 , paddingLeft: '20px' }

const renderCardItem = (item, index) => {
    return (
        <Grid container  key={index} sx={container}>
            <Grid sx={imgGrid} item xs={4}>
                <img src={item.image} alt={item.name} style={img}/>
            </Grid>
            <Grid sx={contentGrid} item xs={8}>
                <Typography variant="h4" sx={text}>{item.name}</Typography>
                <Typography variant="body1" sx={text}>{item.overview}</Typography>
                <Divider sx={text}/>
                <Typography variant="h5" sx={title}>Main Benifits</Typography>
                <ul style={listUl}>
                    {item.benifits.map((p) => <li key={p} style={list}>{p}</li>)}
                </ul>
                <Typography variant="h5" sx={title}>Annual Fees</Typography>
                <ul style={listUl}>
                    {item.annualFees?.mainCard !== undefined && 
                        (<li style={list}>Main Card: {item.annualFees?.mainCard} VNĐ</li>)
                    }
                    {item.annualFees?.otherCard !== undefined && 
                        (<li style={list}>Other Card: {item.annualFees?.otherCard} VNĐ</li>)
                    }
                </ul>
                <Typography variant="body1">※ {item.description}</Typography>
            </Grid>
        </Grid>
    )
}

export default function ListCard() {
    return (
        <Box
            sx={box}
        >
            {ListCardItem.map((item, index) => {
                return renderCardItem(item, index)
            })}
        </Box>
    )
}